import * as React from 'react';

const CodeChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M15.58 8.71l1.417-1.418.354.355 3.292 3.3 1.064 1.064-.353.354-.71.71-3.625 3.633-1.417-1.419 3.27-3.278-3.292-3.3zm-7.16 6.58l-1.417 1.418-.354-.355-3.292-3.3-1.064-1.064.353-.354.71-.71 3.625-3.633 1.417 1.419-3.27 3.278 3.292 3.3zm6.925-12.715l-5.16 19.26-1.95-.523 5.16-19.26 1.95.523z"
            fillRule="nonzero"
        />
    </svg>
);

CodeChunkySvg.displayName = 'CodeChunkySvg';
export default CodeChunkySvg;
